var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Link } from "@lululemon/ecom-pattern-library-link";
import { useMessages, getMappedSource, usMessages, trackComponentEvent } from "@lululemon/auth-common";
import styles from "./continue-as-guest.module.scss";
var defaultTrackingDetails = {
    id: "login-continue-guest",
    type: "link",
    text: usMessages["account.login.continueAsGuest"]
};
export var ContinueAsGuest = function (_a) {
    var onClick = _a.onClick, source = _a.source, continueAsGuestCallback = _a.continueAsGuestCallback;
    var messages = useMessages().messages;
    var trackingSource = getMappedSource(source);
    var onClickWithTracking = function (e) {
        e.preventDefault();
        trackComponentEvent(__assign(__assign({}, defaultTrackingDetails), (trackingSource && { source: trackingSource })));
        onClick === null || onClick === void 0 ? void 0 : onClick();
        continueAsGuestCallback === null || continueAsGuestCallback === void 0 ? void 0 : continueAsGuestCallback();
    };
    return (<section className={styles.continueAsGuest}>
      <Link variant="underline" onClick={onClickWithTracking}>
        {messages["account.login.continueAsGuest"]}
      </Link>
    </section>);
};
export default ContinueAsGuest;
